import { ErrorOutlineOutlined, WarningAmberOutlined } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { useTranslations } from '@/i18n/use-translations';
import type { ContributorMediaProcessingIssue } from './contributor-role-media.utils';

export function MediaProcessingIssueIcon({
  issue,
  size = 24,
}: {
  issue?: ContributorMediaProcessingIssue;
  size?: number;
}) {
  const t = useTranslations();

  if (!issue) {
    return null;
  }

  const label =
    issue === 'error' ? t('media.processing.status.failed') : t('media.processing.status.readyWithLimitations');

  return (
    <Tooltip title={label}>
      {issue === 'error' ? (
        <ErrorOutlineOutlined color="error" aria-label={label} sx={{ width: size, height: size, flexShrink: 0 }} />
      ) : (
        <WarningAmberOutlined color="warning" aria-label={label} sx={{ width: size, height: size, flexShrink: 0 }} />
      )}
    </Tooltip>
  );
}
